module.exports = __webpack_public_path__ + "img/EposNow.d782f63b.svg";